import { createSlice } from "@reduxjs/toolkit";
// import { AppState } from "./store";
import { metaMaskHooks, metaMask } from "../../utils/connectors";
import { coinbaseHooks, coinbaseWallet } from "../../utils/connectors";
import { walletConnectHooks, walletConnect, connectPhantomWallet } from "../../utils/connectors";
import { METAMASK, COINBASE, WALLETCONNECT, PHANTOM } from "../../utils/wallet";
import { ReactComponent as MetaMaskIcon } from "../../assets/icons/wallet/metamask.svg";
import { ReactComponent as CoinbaseIcon } from "../../assets/icons/wallet/coinbase.svg";
import { ReactComponent as WalletConnectIcon } from "../../assets/icons/wallet/walletconnect.svg";
import { ReactComponent as PhantomIcon } from "../../assets/icons/wallet/phantom.svg";
import { setAccountNotification } from "./accountNotifications";
import axios from "../../utils/axios";
import { config } from "../../config";
import { shortenString } from "../../utils/strings";
import { Connection, PublicKey, clusterApiUrl, Transaction } from "@solana/web3.js";
import { Token, TOKEN_PROGRAM_ID, getOrCreateAssociatedTokenAccount } from "@solana/spl-token";
import bs58 from "bs58";

// 初始化 Solana 连接器
export const SOLANA_NETWORK = config.SOLANA_RPC; // 或 'devnet', 'testnet' 根据需要选择
export const solanaConnection = new Connection(SOLANA_NETWORK);

const base_url = config.SSO_API_URL;
const defaultHeader = {
  Accept: "application/json",
  "Content-Type": "application/json"
};

export const WALLET_TYPES = {
  metamask: "metamask",
  coinbase: "coinbase",
  phantom: "phantom"
};

export const WALLET_CONNECTION_TYPES = {
  bind: "bind",
  connect: "connect"
};

export const WALLET_CONFIG = {
  // metamask: {
  //   name: METAMASK,
  //   hook: metaMaskHooks,
  //   connector: metaMask,
  //   Icon: MetaMaskIcon
  // },
  // coinbase: {
  //   name: COINBASE,
  //   hook: coinbaseHooks,
  //   connector: coinbaseWallet,
  //   Icon: CoinbaseIcon
  // },
  // walletconnect: {
  //   name: WALLETCONNECT,
  //   hook: walletConnectHooks,
  //   connector: walletConnect,
  //   Icon: WalletConnectIcon
  // }
  phantom: {
    name: PHANTOM,
    hook: {},
    connector: connectPhantomWallet,
    Icon: PhantomIcon
  }
};

// Initial state
const initialState = {
  walletDialogOpen: false,
  bindWalletNoticeOpen: false,
  connectionType: WALLET_CONNECTION_TYPES.bind,
  selectedWallet: WALLET_TYPES.phantom,
  isLoading: false
};

// Actual Slice
export const slice = createSlice({
  name: "wallet",
  initialState,
  reducers: {
    // Action to set the authentication status
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setWalletDialogOpen(state, action) {
      state.walletDialogOpen = action.payload.open || false;
      state.connectionType = action.payload.type
        ? WALLET_CONNECTION_TYPES[action.payload.type]
        : WALLET_CONNECTION_TYPES.connect;
    },
    setBindWalletNotice(state, action) {
      state.bindWalletNoticeOpen = action.payload;
    },
    setSelectedWallet(state, action) {
      state.connectedWallet = WALLET_TYPES[action.payload];
    },
    resetWalletDialog(state) {
      state.walletDialogOpen = false;
    },
    setConnectionType(state, action) {
      state.connectionType = WALLET_CONNECTION_TYPES[action.payload];
    }
  }
});

export const {
  setIsLoading,
  setWalletDialogOpen,
  setWalletConfig,
  setSelectedWallet,
  resetWalletDialog,
  setBindWalletNotice,
  setConnectionType
} = slice.actions;

export default slice.reducer;

export function isBound({ walletAddress }) {
  return async (dispatch) => {
    dispatch(slice.actions.setIsLoading(true));
    try {
      const { data } = await axios.get(`/wallet/sol/is-bound`, {
        params: { walletAddress },
        baseURL: base_url
      });
      dispatch(slice.actions.setIsLoading(false));
      return data?.bound;
    } catch (error) {
      dispatch(setWalletDialogOpen(false));
      dispatch(slice.actions.setIsLoading(false));
      dispatch(setAccountNotification(error));
    }
  };
}
export function bindChallenge({ email, walletAddress }) {
  return async (dispatch) => {
    dispatch(slice.actions.setIsLoading(true));
    try {
      const { data } = await axios.post(
        `/wallet/sol/challenge/bind-account`,
        { email, walletAddress },
        {
          baseURL: base_url
        }
      );
      dispatch(slice.actions.setIsLoading(false));
      return data;
    } catch (error) {
      dispatch(setWalletDialogOpen(false));

      dispatch(slice.actions.setIsLoading(false));
      dispatch(setAccountNotification(error));
    }
  };
}
export function bind({ token, walletAddress, signature }) {
  return async (dispatch) => {
    dispatch(slice.actions.setIsLoading(true));
    try {
      await axios.post(
        `/wallet/sol/bind-to-account`,
        { walletAddress, signature },
        {
          headers: { ...defaultHeader, Authorization: `Bearer ${token}` },
          baseURL: base_url
        }
      );
      dispatch(slice.actions.setIsLoading(false));
      return true;
    } catch (error) {
      dispatch(setWalletDialogOpen(false));

      dispatch(slice.actions.setIsLoading(false));
      dispatch(setAccountNotification(error));
    }
  };
}

export function wrongWalletAlert(wallet, action = "withdrawal") {
  return async (dispatch) => {
    dispatch(
      setAccountNotification(
        {
          message: `Please switch to wallet: ${shortenString(wallet)} for ${action}`
        },
        5000
      )
    );
  };
}

export function wrongNetworkAlert(network, action = "withdrawal") {
  return async (dispatch) => {
    dispatch(
      setAccountNotification(
        {
          message: `Please switch to ${network} for ${action}`
        },
        5000
      )
    );
  };
}
export const connectSolanaWallet = async () => {
  try {
    const { solana } = window;
    if (solana && solana.isPhantom) {
      const response = await solana.connect();
      return response.publicKey.toString();
    } else {
      throw new Error("Phantom Wallet not found. Please install it.");
    }
  } catch (error) {
    console.error("Error connecting to Solana wallet:", error);
    return null;
  }
};

export const getConnectedSolanaWalletAddress = async () => {
  try {
    const { solana } = window;
    if (solana && solana.isPhantom) {
      const response = await solana.connect({ onlyIfTrusted: true });
      return response.publicKey.toString();
    } else {
      throw new Error("Phantom Wallet not found. Please install it.");
    }
  } catch (error) {
    console.error("Error getting connected Solana wallet address:", error);
    return null;
  }
};

export const getTokenBalance = async (walletAddress, tokenMintAddress) => {
  try {
    // 创建PublicKey实例
    // const mintPublicKey = new PublicKey(tokenMintAddress);
    const walletPublicKey = new PublicKey(walletAddress);
    const connection = solanaConnection;
    // 获取所有代币账户
    const tokenAccounts = await connection.getParsedTokenAccountsByOwner(walletPublicKey, {
      programId: TOKEN_PROGRAM_ID
    });

    // 查找指定代币的账户
    const tokenAccount = tokenAccounts.value.find(
      (account) => account.account.data.parsed.info.mint === tokenMintAddress
    );

    if (tokenAccount) {
      // 获取余额
      const balance = tokenAccount.account.data.parsed.info.tokenAmount.uiAmount;
      return balance;
    } else {
      return 0;
    }
  } catch (err) {
    console.error("Error fetching token balance:", err);
  } finally {
  }
};
export async function clientSign(serializedTx) {
  const connection = new Connection(config.SOLANA_RPC, "confirmed");
  let tx;
  let signedTx;

  // 检查是否安装了 Phantom 钱包
  if (!window.solana || !window.solana.isPhantom) {
    console.error("Phantom wallet is not installed.");
    return;
  }

  try {
    // 请求连接 Phantom 钱包
    await window.solana.connect();
  } catch (error) {
    console.error("Failed to connect to Phantom wallet:", error);
    return;
  }

  try {
    // 将交易从 Base64 转换为 Transaction 对象
    tx = Transaction.from(Buffer.from(serializedTx, "base64"));
  } catch (error) {
    console.error("Failed to parse transaction:", error);
    return;
  }

  try {
    // 唤起 Phantom 钱包进行签名
    signedTx = await window.solana.signTransaction(tx);
  } catch (error) {
    console.error("Failed to sign transaction:", error);
    return;
  }

  try {
    // 发送已签名的交易
    const txId = await connection.sendRawTransaction(signedTx.serialize(), { maxRetries: 5 });
    console.log("Transaction sent with ID:", txId);
    return txId;
  } catch (error) {
    console.error("Failed to send transaction:", error);
  }
}
